<template>
    <main class="-mt-32">
        <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
            <div class="overflow-hidden bg-white shadow sm:rounded-md">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex rounded-md shadow-sm">
                        <div class="relative flex-grow focus-within:z-10">
                            <div
                                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                            >
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="w-5 h-5 text-gray-400"
                                >
                                    <path
                                        d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                                    ></path>
                                    <path
                                        d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
                                    ></path>
                                </svg>
                            </div>
                            <input
                                v-model="query"
                                class="block w-full pl-10 transition duration-150 ease-in-out rounded-none form-input rounded-l-md sm:text-sm sm:leading-5"
                            />
                        </div>
                    </div>
                </div>
                <div class="flex flex-col">
                    <div
                        class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                    >
                        <div
                            class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow main-container sm:rounded-lg"
                        >
                            <div class="scrollable" @scroll="scroll">
                                <table class="min-w-full table-fixed">
                                    <thead>
                                        <tr>
                                            <th
                                                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 table-cell bg-gray-50"
                                            >
                                                Mese
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            :class="{
                                                'bg-gray-100': index % 2,
                                            }"
                                            v-for="(invoice, index) in filtered"
                                            :key="index"
                                        >
                                            <td
                                                class="flex px-6 py-4 text-sm font-medium leading-5 text-right whitespace-no-wrap"
                                            >
                                                <span
                                                    @click="download(invoice)"
                                                    class="text-indigo-600 cursor-pointer hover:text-indigo-900 focus:outline-none focus:underline"
                                                >
                                                    <svg
                                                        fill="currentColor"
                                                        viewBox="0 0 20 20"
                                                        class="w-5 h-5"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
                                                            clip-rule="evenodd"
                                                        ></path>
                                                    </svg>
                                                </span>
                                                {{ invoice.label }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        history: {
            required: false,
        },
    },

    data: () => {
        return {
            loaded: false,
            display: false,
            query: "",
            elements: 0,
            pagination: 50,
            page: 1,
        };
    },

    computed: {
        ...mapState("invoice", ["invoices"]),
        filtered() {
            this.loaded;
            return _.filter(this.invoices, (element) => {
                return (
                    element.label
                        .toUpperCase()
                        .search(this.query.toUpperCase()) > -1
                );
            }).slice(0, this.page * this.pagination);
        },
    },

    methods: {
        scroll() {
            let container = $(".main-container");
            let height = container.scrollHeight - container.offsetHeight;
            let scrollTop = container.scrollTop;
            if (
                this.page * this.pagination < this.elements &&
                height - scrollTop < container.offsetHeight
            ) {
                this.page++;
            }
        },
        download(invoice) {
            this.$store.dispatch("invoice/DOWNLOAD", invoice);
        },
    },

    async mounted() {
        await this.$store.dispatch("invoice/INDEX");
        this.elements = this.invoices.length;
        this.loaded = true;
    },
};
</script>
